import { createFileRoute } from "@tanstack/react-router";
import { AdminPageHeader } from "@/components/admin/admin-page-header";
import { CompanyPage } from "@/components/organisations";

function CompanyManagement() {
  return (
    <div className="p-4 lg:p-7 space-y-6">
      <AdminPageHeader
        title="Company Management"
        description="Every organization on the platform. Drill into a company to manage its users, assets, and details."
      />
      <CompanyPage />
    </div>
  );
}

export const Route = createFileRoute("/dashboard/_admin/company/")({
  component: CompanyManagement,
  staticData: {
    title: "Company Management",
  },
});
